import { referenceToOptionV2 as defaultReferenceToOptionV2 } from 'reference-resolvers-lite/utils/referenceToOption';
export const referenceToOptionWithReferenceV2 = reference => Object.assign({}, defaultReferenceToOptionV2(reference), {
  reference
});